<template>
    <div class="handbook-version-select">
        <label class="sr-only" :for="id">{{ $t("handbook.product_select") }}</label>
        <select :value="currentProduct.slug" @change="changeProduct" :id="id">
            <option v-for="product in products" :value="product.slug">{{ product.title }} {{ $t("global.handbook") }}</option>
        </select>
        <span aria-hidden="true">{{ currentProduct.title }} {{ $t("global.handbook") }}</span>
        <div>
            <ProIcon icon="select-arrow" />
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    computed: {
        ...mapGetters({
            currentProduct: "handbook/getCurrentProduct",
            products: "handbook/getProducts",
        }),
    },
    props: {
        id: String,
    },
    methods: {
        changeProduct(e) {
            this.$store.commit("handbook/setPages", []);

            this.$router.push(
                this.localePath({
                    name: "handbook-product-all",
                    params: { product: e.target.value, pathMatch: "introduction" },
                })
            );
        },
    },
};
</script>
